import React from 'react';

import autoBind from 'react-autobind';
import axios from 'axios'

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"

import ProgressDialog from "composer/views/ProgressDialog.jsx"

var CancelToken = axios.CancelToken;
var cancelRequest;

class FilePicker extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      isUploading: false,
      uploadFile: false,
    };
    autoBind(this);
  }

  handleUploadProgress(progressEvent) {
    var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
    this.state.uploadProgress = percentCompleted;
    this.refs.progressDialog.setProgress(percentCompleted);
  }

  handleUploadResponse(response) {
    if (response.status == 200) {
      let resp = response.data;
      if (this.props.onUploadSuccess != null) {
        this.props.onUploadSuccess(resp);
      }
      this.setState({
        uploadProgress: 100,
        isUploading: false,
      });
      this.state.uploadProgress = 100;
      this.state.isUploading = false;
      this.props.root.addNotification(Localization.strings.UPLOADED);
      this.refs.progressDialog.setProgress(100);
      this.refs.progressDialog.setDescription(Localization.strings.UPLOAD_COMPLETE);
      this.refs.progressDialog.showDoneButton();
    }
  }

  uploadFile(files) {
    let progressCallback = this.handleUploadProgress;
    let responseCallback = this.handleUploadResponse;

    this.resetUploadProgress();
    if (files.length > 0) {
      let file = files[0];
      let fileOK = false;
      fileOK = this.checkFileExtension(file['name'], this.props.allowedExtension? this.props.allowedExtension : "");
      if (!fileOK) {
        this.props.root.addNotification(Localization.strings.UPLOAD_FILE_TYPE_REMINDER);
      }
      else {
        let formData = new FormData();
        formData.append(
          "selectedFile",
          file,
          file.name
        );

        var config = {
          onUploadProgress: function(progressEvent) {
            progressCallback(progressEvent);
          },
          params: {
            locale_id: this.props.localeId,
            user_id: this.props.root.getMyUserId(),
          },
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c;
          }),
        }

        axios.post(Config.UPLOAD_PATH(), formData, config)
          .then(function (response) {
            responseCallback(response);
          })
          .catch(function(error){
            console.log(error);
          });

        this.refs.progressDialog.setProgress(0);
        this.refs.progressDialog.setDescription("");
        this.refs.progressDialog.show(this.uploadProgressCancelClicked, this.uploadProgressDoneClicked);
        this.setState({ isUploading: true });
        this.state.isUploading = true;
      }
    }
  }

  getFileExtension(filename) {
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
  }

  checkFileExtension(filename, allowedExtension) {
    let fileOK = false;

    if (allowedExtension == undefined || allowedExtension == "") {
      return true;
    }

    filename = filename.toLowerCase();
    allowedExtension = allowedExtension.toLowerCase();

    let extension = this.getFileExtension(filename);
    if (extension == undefined) {
      return false;
    }

    extension = extension.trim();
    let extensionArray = allowedExtension.split(',');
    for (let i = 0; i < extensionArray.length; i++) {
      if (extension == extensionArray[i].trim()) {
        fileOK = true;
      }
    }

    return fileOK;
  }

  handleChangeClicked() {
    let dialogText = {
      title: Localization.strings.DELETE,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    };
    this.props.root.refs.confirmDialog.show(dialogText, this.changeFileConfirmClicked, this.changeFileCancelClicked);
  }

  changeFileConfirmClicked() {
    if (this.props.onChangeFileConfirm != null) {
      this.props.onChangeFileConfirm();
    }
  }

  changeFileCancelClicked() {

  }

  abortUpload() {
    this.setState({ isUploading: false });
    this.state.isUploading = false;
    this.resetUploadProgress();
    if (this.props.onAbortUpload != null) {
      this.props.onAbortUpload();
    }
    this.props.root.addNotification(Localization.strings.UPLOAD_FAILED);
  }

  resetUploadProgress() {
    this.setState({ uploadProgress: 0 });
    this.state.uploadProgress = 0;
  }

  uploadProgressCancelClicked() {
    if (cancelRequest != null) {
      cancelRequest();
      cancelRequest = null;
    }
    this.abortUpload();
  }

  uploadProgressDoneClicked() {

  }

  render() {
    return (
      <div>
        <ProgressDialog parent={this} root={this.props.root} ref="progressDialog"/>
      </div>
    )
  }
}

export default FilePicker;
